import { render, staticRenderFns } from "./FtthRegrades.vue?vue&type=template&id=39148a96&scoped=true&"
import script from "./FtthRegrades.vue?vue&type=script&lang=js&"
export * from "./FtthRegrades.vue?vue&type=script&lang=js&"
import style0 from "./FtthRegrades.vue?vue&type=style&index=0&id=39148a96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39148a96",
  null
  
)

export default component.exports